import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

export function initSentry() {
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_APP_STAGE ?? 'local',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: import.meta.env.VITE_APP_STAGE === 'prod' ? 0.2 : 1.0,
    replaysSessionSampleRate: import.meta.env.VITE_APP_STAGE === 'prod' ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
